module.exports = __webpack_public_path__ + "img/circle-4.49488bed.png";